var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"options-list"},_vm._l((_vm.options),function(ref){
var id = ref.id;
var title = ref.title;
var linkText = ref.linkText;
var link = ref.link;
return _c('li',{key:id,staticClass:"options-list__item"},[_c('checkbox-toggle',{staticClass:"checkbox-toggle--bold",attrs:{"handleCheckbox":_vm.handleCheckbox,"model":id,"service":_vm.service,"checked":_vm.services[id],"title":title,"linkText":linkText || _vm.links.copyright.text,"link":link || _vm.links.copyright.link,"parent":"checkboxes","styles":_vm.styles}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }